import React, { Fragment, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { FillingStationType } from '../../../../Models/fillingStationType'
import fillingStationService from '../../../../Services/fillingStationService'
import { HorizontalLoader, Pagination } from '../../../../Components'
import { DateTimeFormatter } from '../../../../Helpers/DateTimeFormatter'
import './Fillingstations.scss'
import { handleError } from 'Helpers'

const FillingStations = () => {
  const [fillingStations, setFillingStations] = useState<FillingStationType[]>([])
  const [loading, setLoading] = useState(false)

  const [pageNumber, setPage] = useState(1)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })
  const getFillingStations = async () => {
    setLoading(true)

    await fillingStationService.getAll(pageNumber).then(
      (response) => {
        setLoading(false)
        setFillingStations(response.data.data.dataset)

        setPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })
      },
      (error) => {
        handleError(error)
        setLoading(false)
      },
    )
  }

  useEffect(() => {
    getFillingStations()
  }, [])

  return (
    <div className='filling-station'>
      <div className='container mt-4'>
        <div className='card border-0'>
          <div className='card-header border-0'>
            <div className='card-header border-0'>
              <div className='row'>
                <div className='col-12 col-md-8 my-auto'>
                  <div className='title'>Filling Stations</div>
                </div>
                <Fragment>
                  <div className='col-6 col-md-4  text-md-end'>
                    <Link to='/filling-stations/create'>
                      <button className='btn btn-respond-req'>Create Filling Station</button>
                    </Link>
                  </div>
                </Fragment>
              </div>
            </div>
          </div>

          <div className='card-body'>
            {loading ? (
              <HorizontalLoader />
            ) : (
              <div className='table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <td>Business Name</td>
                      <td>Branch Name</td>
                      <td>City</td>
                      <td>State</td>
                      <td>Date Created</td>
                      <td>Actions</td>
                    </tr>
                  </thead>
                  <tbody>
                    {fillingStations.map((station) => (
                      <tr key={station.id}>
                        <td>{station.businessName}</td>
                        <td>{station.branchName}</td>
                        <td>{station.city}</td>
                        <td>{station.state}</td>
                        <td>{DateTimeFormatter(station.createdAtISO8601)}</td>
                        <td>
                          <Link
                            to={`/filling-stations/${station.id}`}
                            className='btn btn-sm btn-default'
                          >
                            View
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {paginationData.total >= paginationData.pageSize && (
              <div className='pagination w-100 d-flex justify-content-center'>
                {paginationData.total && (
                  <Pagination
                    className='pagination-bar ps-0'
                    currentPage={Number(paginationData.pageNumber)}
                    totalCount={paginationData.total}
                    pageSize={paginationData.pageSize}
                    onPageChange={(page: React.SetStateAction<number>) => setPage(page)}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FillingStations
